<template>
  <b-reg-flow
    :instance="instance"
    name="reg-flow"
    :dangerously-disable-security-checks="false"
  />
</template>

<script>
export default {
  name: "RegMask",
  data: () => ({
    instance: {},
    loadingProgress: 0,
  }),
  created() {
    this.fetchInstance()
      .then(({ instance }) => {
        this.instance = instance;
        this.loadingProgress = 15;
      });
  },
  methods: {
    fetchInstance() {
      return this.$bom.course.instances.one
        .withId(this.$route.params.id)
        .including("TagsPlugin")
        .fetch();
    },
  },
};
</script>

<style scoped>

</style>
